import { DocumentStorageContextProvider } from 'framework/documentStorage';
import React from 'react';
import { useLocation } from 'react-router-dom';
import useEmployeeDocumentsService from './useEmployeeDocumentsService';

const EmployeeDocumentContextTemplate = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const isGenerateDocumentRoute = pathname.includes('/documents/generate/');
  const actions = useEmployeeDocumentsService(isGenerateDocumentRoute);

  const contextActions = isGenerateDocumentRoute
    ? actions
    : {
        ...actions,
        renderPreviewDocumentTemplate: undefined,
      };

  return <DocumentStorageContextProvider value={contextActions}>{children}</DocumentStorageContextProvider>;
};

export default EmployeeDocumentContextTemplate;
